import React from "react";
import PropTypes from "prop-types";
import { CompanyName } from "MODULES/shared/components";

export function ShippingAddress({ purchaseOrder }) {
  const { ship_to_address: shippingAddress } = purchaseOrder;

  const dropShip = type => ["company", "dropship"].includes(type);
  const shipToShippingType = purchaseOrder.shipping_type;

  return (
    <table className="table table-condensed">
      <tbody>
        {purchaseOrder.ship_to_company && (
          <tr>
            <th className="text-right">Company</th>
            <td>
              <CompanyName company={purchaseOrder.ship_to_company} />
            </td>
          </tr>
        )}
        {shippingAddress.company_name &&
          dropShip(shipToShippingType) && (
            <tr>
              <th className="text-right">Company Name</th>
              <td>{shippingAddress.company_name}</td>
            </tr>
          )}
        {shippingAddress.care_of &&
          dropShip(shipToShippingType) && (
            <tr>
              <th className="text-right">c/o</th>
              <td>{shippingAddress.care_of}</td>
            </tr>
          )}
        <tr key="address">
          <th className="text-right">Address Line</th>
          <td>
            {shippingAddress.line1}
            {shippingAddress.line2 && <br />}
            {shippingAddress.line2 && shippingAddress.line2}
          </td>
        </tr>
        <tr key="city">
          <th className="text-right">City</th>
          <td>{shippingAddress.city}</td>
        </tr>
        <tr key="state">
          <th className="text-right">State/ Province/ Region</th>
          <td>{shippingAddress.state}</td>
        </tr>
        <tr key="zip">
          <th className="text-right">ZIP/ Postal Code</th>
          <td>{shippingAddress.postal_code}</td>
        </tr>
        <tr key="country">
          <th className="text-right">Country</th>
          <td>{shippingAddress.country}</td>
        </tr>
      </tbody>
    </table>
  );
}

ShippingAddress.propTypes = {
  purchaseOrder: PropTypes.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/ShippingAddress.jsx